import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect, useRef } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DefaultLanguage from "./components/Popups/DefaultLanguage";
import IntegrateCalendarPopup from "./components/Popups/IntegrateCalendarPopup";
import Main from "./components/main/Main";
import { TourProvider } from "@reactour/tour";
import { tour } from "../src/components/Tour/tour";
// import { useTour } from "@reactour/tour";
import Popup from "./components/Popups/Popup";
import { setNewUser } from "../src/redux/actions/authActions";
import { db, auth } from "../src/config/firebase-config";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import ExceededPopup from "./components/Popups/ExceededPopup";
import { partialUpdateUser, getCurrentUser, fetchUserData } from "./services/UserService"

function App() {
  // const navigate = useNavigate();

  const dispatch = useDispatch();
  const { calendarIntegrationPopup } = useSelector((state) => state.appReducer);
  const { userData } = useSelector((state) => state.authReducer);
  const { isNewUser } = useSelector((state) => state.authReducer);
  // const [firstUser, setFirstUser] = useState(true);
  const [lockTour, setLockTour] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const disableBody = (target) => disableBodyScroll(target);
  const enableBody = (target) => enableBodyScroll(target);
  // const [isTourOpen, setIsTourOpen] = useState(false);
  const [exceededModal, setExceededModal] = useState(false);
  const [totalMinutes, setTotalMinutes] = useState(0);

  useEffect(() => {
    if(userData){
      let filtered_datalayer = window.dataLayer.filter((row) =>{
        return row.event == "login";
      })
      if(filtered_datalayer.length == 0){
        window.dataLayer.push({
          'event' : 'login',
          'userId' : userData.id //this number must be replaced with an actual User ID
        })
      }
    }
  }, [userData]);

  useEffect(() => {
    const checkUserAuthentication = async () => {
      const user = auth.currentUser;
      if (user && isNewUser) {
        setShowPopup(true);
      }
    };

    checkUserAuthentication();
  }, [isNewUser]);

  const closePopup = () => {
    setShowPopup(false);
    const user = auth.currentUser;
    if (user) {
      // Update the user document
      partialUpdateUser(user.uid, { isNewUser: false },
          (response) => {
            dispatch(setNewUser(false)); // Set isNewUser to false in Redux state
          },
          (error) => {
            console.error("Error updating user document:", error);
          }
      )
    }
  };

  const fetchData = async () => {
    if (userData) {
      if (
        userData?.meetTimeChecker &&
        userData?.meetTimeChecker.hours !== undefined
      ) {
        const totalTime =
        userData?.meetTimeChecker.hours * 60 +
        userData?.meetTimeChecker.minutes +
        userData?.meetTimeChecker.seconds / 60;
        setTotalMinutes(totalTime);
        console.log("TotalMinutes (after state update): ", totalTime);
      }

      const subscriptionData = userData?.subscription || {};
      const subscriptionName = Object.keys(subscriptionData)[0];
      const currentDate = Math.floor(new Date().getTime() / 1000);
      const endDate = subscriptionData?.[subscriptionName]?.periodEnd;
      if (
        subscriptionName === "free" ||
        ((subscriptionName === "productivity pro" || subscriptionName === "business") && endDate >= currentDate)
      ) {
        const limitFromCollection = subscriptionData?.[subscriptionName]?.timeLimit;
        if (limitFromCollection === -1) {
          setExceededModal(false);
        } else if (limitFromCollection < totalMinutes) {
          setExceededModal(true);
        }
      } else {
        setExceededModal(true);
      }
    }
  };

  useEffect(() => {
    fetchData(); // Call fetchData function inside useEffect
  }, [totalMinutes]);

  return (
    <div>
      <ToastContainer />
      <BrowserRouter>
        <TourProvider
          steps={tour(setLockTour)}
          startAt={0}
          disableKeyboardNavigation={true}
          showDots={false}
          showPrevNextButtons={!lockTour}
          prevButton={({ currentStep, setCurrentStep, steps }) => {
            const first = 0;
            const isDisabled = currentStep === first;
            return (
              <button
                onClick={() => {
                  if (!isDisabled) {
                    setCurrentStep((s) =>
                      s === first ? steps.length - 1 : s - 1
                    );
                  }
                }}
                // className={`opacity-0 shadow-sm fade text-white py-[5px] px-[10px] rounded-md transition bg-[#07457f] ${
                //   isDisabled ? " disabled cursor-default " : "cursor-default"
                // }`}
                // disabled={isDisabled}
                className="opacity-0 cursor-default"
                disabled
              >
                Back
              </button>
            );
          }}
          nextButton={({ currentStep, setCurrentStep, steps }) => {
            const last = steps.length - 1;
            const isDisabled = currentStep === last;
            return (
              <button
                onClick={() => {
                  if (last) {
                    setCurrentStep((s) => (s === last ? 0 : s + 1));
                  }
                }}
                className={`shadow-sm fade text-white py-[5px] px-[10px] rounded-md transition bg-[#07457f] cursor-pointer`}
              >
                {isDisabled ? "Restart Tour" : "Next"}
              </button>
            );
          }}
          onClickMask={() => {}}
          afterOpen={disableBody}
          beforeClose={enableBody}
          styles={{
            popover: (base) => ({
              ...base,
              "--reactour-accent": "#07457f",
              borderRadius: "20px",
            }),
            maskArea: (base) => ({ ...base, rx: "10px" }),
            badge: (base) => ({
              ...base,
              width: "40px",
              height: "40px",
              fontSize: "20px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }),
            close: (base) => ({
              ...base,
              width: "12px",
              height: "12px",
              margin: "-3px",
            }),
          }}
        >
          {calendarIntegrationPopup &&
            localStorage.getItem("@auth") &&
            !userData?.defaultLanguage && <IntegrateCalendarPopup />}

          {userData &&
            !userData?.defaultLanguage &&
            localStorage.getItem("@auth") && <DefaultLanguage />}

          {showPopup && userData && userData?.defaultLanguage && (
            <Popup onClose={closePopup} />
          )}
          {exceededModal && (
            <ExceededPopup
              onClose={() => {
                setExceededModal(false);
              }}
            />
          )}
          <Main />
        </TourProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
